import React from "react";
import styled from "@emotion/styled";

import PowerSettingsNew from "@mui/icons-material/PowerSettingsNew";

import Button from "@mui/material/Button";

const Container = styled.div`
  border-left: 0.1px solid rgba(255, 255, 255, 0.5);
`;

const IconButtonContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 100%;
  height: 100%;
`;

const StyledButton = styled(Button)`
  display: flex;
  flex: 1;
  height: 100%;
  align-items: center;
  justify-content: center;
`;

const PowerSettingsNewIcon = styled(PowerSettingsNew)`
  color: rgba(255, 255, 255, 0.8);
`;

type Props = {
  onLogout: React.MouseEventHandler<HTMLButtonElement>;
};

function LogoutButton({ onLogout }: Props): JSX.Element {
  return (
    <Container>
      <StyledButton onClick={onLogout}>
        <IconButtonContainer>
          <PowerSettingsNewIcon />
        </IconButtonContainer>
      </StyledButton>
    </Container>
  );
}

export default LogoutButton;
